import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Books from "./pages/Books";
import BookDetail from "./pages/BookDetail";
import AuthorProfile from "./pages/AuthorProfile";
import PublishWithUs from "./pages/PublishWithUs";
import Districts from "./pages/Districts";
import Studio from "./pages/Studio";
import About from "./pages/About";
import Contact from "./pages/Contact";
import YLGF from "./pages/YLGF";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

// Google Analytics 4 — fire a page_view on every SPA route change.
const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const page_path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <ScrollToTop />
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="books" element={<Books />} />
            <Route path="books/:slug" element={<BookDetail />} />
            <Route path="authors/:slug" element={<AuthorProfile />} />
            <Route path="publish" element={<PublishWithUs />} />
            <Route path="districts" element={<Districts />} />
            <Route path="studio" element={<Studio />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="ylgf" element={<YLGF />} />
            <Route path="cart" element={<Cart />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="order/:orderNumber" element={<OrderConfirmation />} />
          </Route>
        </Routes>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
